<template>
  <div id="flowStep" class='flex-center'  style="background-color: white;padding: 20px;">
    <span v-for='(item,index) in flowList' :key='index' class="step-item">
        <span :class="step>=index?'num active':'num'">{{index+1}}</span>
				<div class="info-wrap">
					<span>{{item.info}}</span>
					<p class="sub" v-if="item.sub">{{item.sub}}</p>
				</div>
        <span :class="step>index?'line active':'line'" v-show='index!==flowList.length-1'></span>
    </span>
  </div>
</template>
<script>
export default {
    props:{
        flowList:{
            type:Array
        },
        step:{
            type:Number
        }
    },
    data(){
        return{
        }
    }
};
</script>
<style lang="scss">
@import "style/fontSize.scss";
#flowStep {
	.step-item{
		white-space: nowrap;
    display: inline-block;
	}
  .num {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #e6e6e6;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    color: #fff;
    display: inline-block;
		margin-right: 12px;
		vertical-align: top;
		margin-top: -2px;
	}
	.info-wrap{
		display: inline-block;
		.sub{
			margin: 0;
			max-width: 170px;
			font-size: 12px;
			color: #666666;
			white-space: normal;
		}
	}
  .line{
    display: inline-block;
    background: #e6e6e6;
    width: 247px;
    height: 1px;
    margin: 0 20px;
		vertical-align: top;
    margin-top: 10px;
  }
  .active{
      background: #cfa972;
  }

}
</style>
